module.exports = __webpack_public_path__ + "static/media/wind.502e8679.gif";